let mockGroups = [
  { id: 1, code: 4, nameEn: "D", employeeQty : 0 ,startDate : "03-09-2025" , endDate:"08-09-2025", shift:"Morning to evening"},
  { id: 2, code: 2, nameEn: "B", employeeQty : 0 ,startDate : "03-09-2025" , endDate:"13-09-2025", shift:"Morning to night"},
  { id: 3, code: 1, nameEn: "A", employeeQty : 1,startDate : "03-09-2025" , endDate:"11-09-2025", shift:"Evening"},
  { id: 4, code: 5, nameEn: "C", employeeQty : 0 ,startDate : "03-09-2025" , endDate:"05-09-2025", shift:"Daily"},
];
let grpIdCounter = mockGroups.length + 1;

const GroupAPI = {
  getAll: async () =>
    new Promise((resolve) => {
      setTimeout(() => resolve({ data: { data: [...mockGroups] } }), 300);
    }),

  add: async (newData) =>
    new Promise((resolve) => {
      setTimeout(() => {
        const newItem = { ...newData, id: grpIdCounter++ };
        mockGroups = [...mockGroups, newItem];
        resolve({ data: { data: newItem } });
      }, 300);
    }),

  update: async (id, updatedData) =>
    new Promise((resolve) => {
      setTimeout(() => {
        const idx = mockGroups.findIndex((g) => g.id === id);
        if (idx !== -1) mockGroups[idx] = { ...mockGroups[idx], ...updatedData };
        resolve({ data: { data: mockGroups[idx] } });
      }, 300);
    }),

  delete: async (ids) =>
    new Promise((resolve) => {
      setTimeout(() => {
        const idsArr = Array.isArray(ids) ? ids : [ids];
        mockGroups = mockGroups.filter((g) => !idsArr.includes(g.id));
        resolve({ status: 200, data: { deletedIds: idsArr } });
      }, 300);
    }),
};

export default GroupAPI;
